<p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event.index)" data-cy="dashboard-date-tabs">
  <p-tabPanel header="WEEK"></p-tabPanel>
  <p-tabPanel header="MONTH"></p-tabPanel>
  <p-tabPanel header="YEAR"></p-tabPanel>
  <p-tabPanel header="CUSTOM">
    <ng-template pTemplate="content">
      <div class="custom-range">
        <p-calendar
          [(ngModel)]="customRange"
          selectionMode="range"
          [readonlyInput]="true"
          [showIcon]="true"
          placeholder="Select date range"
          dateFormat="mm/dd/yy"
        ></p-calendar>
        <button
          pButton
          type="button"
          label="Apply"
          class="p-button-outlined"
          [disabled]="!customRange || customRange.length < 2"
          (click)="applyCustomRange()"
        ></button>
      </div>
    </ng-template>
  </p-tabPanel>
</p-tabView>
